export default __webpack_public_path__ + "static/media/martini_IDP.a5d308f4.png";